<template>
  <div class="inlin-timeslot-collection-selector">
    <span v-if="showText">
      {{text}}
    </span>

    <el-popover
      placement="bottom"
      title="Select a default schedule"
      width="300"
      trigger="click"
      v-model="popover_visible">

      <el-radio-group
        class="timeslot-collection-radio-group p-1"
        :value="value"
        @input="onInput">
        <el-radio
          v-for="item in timeslotCollectionsSelectOptions"
          :key="item.value"
          :label="item.value"
          :style="{ width: '100%', color: item.color }">
          {{item.label}}
        </el-radio>
      </el-radio-group>

      <info-box title="Goalpilot Tip">
        Assigning a default schedule is an easy way to tell the Goalpilot prediction engine
        when you plan to do something, so we can give you and even your team members
        an estimate when you can approximately finish a project or task.
        <br /><br />
        You can manage your time <router-link to="/calendar/manage-time-and-priorities">here</router-link>.
      </info-box>

      <el-button
        slot="reference"
        :size="size"
        :style="{
          padding: '9px 10px',
          backgroundColor: buttonColor,
          borderColor: buttonColor,
          color: 'white'
        }"
        icon="el-icon-arrow-down">
      </el-button>

      <!-- el-icon-arrow-down -->
      <!-- el-icon-caret-bottom -->

    </el-popover>
  </div>
</template>

<script>

export default {
  props: {
    value: {},
    showText: { default: true },
    size: { default: 'small' }
  },
  data: () => ({
    popover_visible: false,
  }),
  computed: {
    timeslotCollectionList() {
      return this.$models.timeslotCollection.getList().itemsAsArray();
    },

    timeslotCollectionsSelectOptions() {
      let timeslotCollectionList = this.timeslotCollectionList.map(item => {
        return { value: item.$id, label: item.name, color: item.color }
      });
      // Don't show blocker?
      let neverEntry = { value: null, label: "<No default schedule>", color: '#888888' };
      return [ ...timeslotCollectionList, neverEntry ];
    },

    timeslotCollectionSelected() {
      return this.timeslotCollectionList.find(item => item.$id === this.value);
    },

    text() {
      return this.timeslotCollectionSelected
        ? this.timeslotCollectionSelected.name
        : '';
    },

    buttonColor() {
      return this.timeslotCollectionSelected
        ? this.timeslotCollectionSelected.color
        : 'grey';
    }
  },
  methods: {
    onInput(value) {
      this.popover_visible = false;
      this.$emit('input', value)
    }
  }
}
</script>

<style>
.inlin-timeslot-collection-selector {
  display: inline-block;
  font-weight: bold;
}
</style>
